import { Component, Host, Optional, inject } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Route, Router } from '@angular/router';

import { UserService } from '../../../user/services/user.service';
import { PermissionHelper } from '../../../../shared/helpers/permission.helper';
import { map, Observable, distinctUntilChanged } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent {
  private readonly _routes: Route[] = [];
  private _userService = inject(UserService);

  constructor(
    @Host() @Optional() private _sidenav: MatSidenav,
    _router: Router
  ) {
    this._routes = _router.config;
  }

  public getRoutes(): Route[] {
    return this._routes;
  }

  public close(): void {
    if (this._sidenav) {
      this._sidenav.close();
    }
  }

  isMenuItemDisplayed(route: Route): Observable<boolean> {
    // Check if route has a title (required for menu display)
    const hasTitle = route.data?.['title'];
    if (!hasTitle) {
      return new Observable(observer => observer.next(false));
    }

    // Create an observable that immediately emits the current token state
    // and then continues to emit user state changes
    return this._userService.getUser().pipe(
      map(user => {
        const hasToken = this._userService.hasToken();

        // If no token at all, hide menu items
        if (!hasToken) {
          return false;
        }

        // If we have a token but user data is still loading, show menu items immediately
        // This allows the navigation to appear right after successful authentication
        if (hasToken && !user) {
          return true;
        }

        // User is fully loaded, do full permission check
        if (user) {
          const canUserActivate = PermissionHelper.canUserActivate(user, route);
          return canUserActivate;
        }

        return false;
      }),
      distinctUntilChanged() // Only emit when the result actually changes
    );
  }

}
